/* eslint-disable no-param-reassign */
const env = require('bench-environment').default;

function benchLocation(envLocation, $window) {
  let hostname;
  let protocol;

  if ($window.location && $window.location.hostname && $window.location.protocol) {
    hostname = $window.location.hostname.replace(
      /^((bktools(\.in)?)|(dashboard(\.in)?)|bk|app)\./g,
      '',
    );
    protocol = $window.location.protocol;
  } else {
    hostname = '';
    protocol = '';
  }

  return {
    bkTools() {
      return envLocation.bkTools;
    },

    bookkeepingApiRoot() {
      return envLocation.v2BookkeepingApiRoot;
    },

    financialDataApiRoot() {
      return envLocation.v2FinancialDataApiRoot;
    },

    apiRoot() {
      // localhost logic is needed for angular tests, because it does not expect the protocol and
      // domain in the url
      return hostname === 'localhost' || hostname === '' ? '' : envLocation.apiRoot;
    },

    cwa() {
      return `${protocol}//app.${hostname}`;
    },

    gotoLogin(opts = {}) {
      window.localStorage.removeItem('isNewUISwitchBannerVisible');
      const isOktaLogin = JSON.parse($window.localStorage.getItem('openid_okta'));
      const qs = opts.redirect ? `?redirect_url=${encodeURIComponent($window.location.href)}` : '';
      if (isOktaLogin) {
        $window.location.href = `${envLocation.apiRoot}/oauth2/authorization/okta${qs}`;
      } else {
        $window.location.href = `${envLocation.websiteRoot}/login${qs}`;
      }
    },

    logout() {
      $window.location.href = `${envLocation.websiteRoot}/logout`;
    },

    goToBusinesses() {
      const { pathname, search } = window.location;
      const encodedSearch = search ? `originalParams=${encodeURIComponent(search)}` : '';
      const redirectParam = pathname ? `?redirectDestination=${pathname}&` : '?';
      $window.location.href = `${this.cwa()}/businesses${redirectParam}${encodedSearch}`;
    },

    gotoErrorPage(code) {
      $window.location.href = `${envLocation.websiteRoot}/${code}`;
    },

    goToDashboard() {
      $window.location.href = `${protocol}//dashboard.in.${hostname}`;
    },

    gotoBkTools(loc) {
      $window.location.href = `${this.bkTools()}${loc}`;
    },

    openBkTools(loc) {
      $window.open(`${this.bkTools()}${loc}`, '_blank');
    },

    openRoot(loc) {
      $window.open(`${envLocation.websiteRoot}${loc}`, '_blank');
    },
  };
}

module.exports = angular
  .module('bench.service.benchLocation', [])
  .constant('envLocation', env.location)
  .factory('benchLocation', benchLocation);
